<template lang="html">
    <div class="page" v-if="player" id="playerMessage">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Sent Messages</h2>
                <ul class="links">
                    <li>
                        <router-link
                            class="cancel"
                            :to="{ name: 'proPlayer', params: { id: $route.params.id } }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <span class="info player">{{ player.first_name }} {{ player.last_name }}</span>

            <router-link
                class="button dark mb"
                type="button"
                name="button"
                :to="{ name: 'proPlayerMessagesNew', query: { id: player.id, from: 'player' } }"
            >
                New message
                <plus-icon class="icon" />
            </router-link>

            <ul id="messages">
                <message-item v-for="message in messages" :message="message" :key="message.id" />
            </ul>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon, PlusIcon } from "vue-feather-icons";
import MessageItem from "@/components/Pro/Messages/Message-item";
export default {
    name: "messages",
    components: {
        MessageItem,
        XIcon,
        FadeImage,
        PlusIcon,
    },
    mounted() {
        if (!this.$store.state.activePlayer) {
            this.$store.dispatch("getPlayer", this.$route.params.id);
        }
        this.getMessages();
    },
    data() {
        return {
            messages: [],
        };
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
    methods: {
        getMessages() {
            window.axios.get("/player/" + this.$route.params.id + "/messages").then((messages) => {
                this.messages = messages.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#playerMessage {
    .player {
        font-size: 16px;
        margin-bottom: 10px;
    }
}
</style>
